import { createContext } from 'react'

export const GretaAIChatContext = createContext()
